import { type KeyboardEvent, useCallback, useRef } from 'react';
import { useTimeout } from '@toss/react';
import { MagnifingglassIcon, TextField } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { XSmallCircleColorIcon } from '@/icons';
import { Button, IconButton } from '@/ui_v3';
import { cn } from '@/utils';
interface SearchInputProps {
  keyword: string;
  hasKeywordChanged: boolean;
  onKeywordChange: (keyword: string) => void;
  onSearchSubmit: () => void;
  onSearchClear: () => void;
}

/**
 * 성취기준 검색 입력 컴포넌트 (Controlled Component)
 * 키워드 입력, 엔터키/버튼 검색
 */
export const SearchInput = ({
  keyword,
  hasKeywordChanged,
  onKeywordChange,
  onSearchSubmit,
  onSearchClear
}: SearchInputProps) => {
  const {
    t
  } = useTranslation(['build']);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (!hasKeywordChanged) return;
    if (e.key === 'Enter') {
      onSearchSubmit();
    }
  }, [hasKeywordChanged, onSearchSubmit]);
  useTimeout(() => {
    inputRef.current?.focus();
  }, 10);
  return <TextField.Root required data-sentry-element="unknown" data-sentry-component="SearchInput" data-sentry-source-file="SearchInput.tsx">
      <TextField.Input intent="neutral" ref={inputRef} value={keyword} autoFocus onChange={e => onKeywordChange(e.target.value)} onKeyDown={handleKeyDown} placeholder={t('build:build.standard.search.query.placeholder')} className="w-full" leftSlot={<MagnifingglassIcon size="md" fill={ICON_COLOR.neutral} className="flex-shrink-0" />} rightSlot={<div className="flex flex-row items-center gap-4xs">
            <IconButton variant="transparent" intent="neutral" onClick={onSearchClear} className={cn(!keyword && 'hidden')} size="md">
              <XSmallCircleColorIcon size="md" fill={ICON_COLOR.neutral} />
            </IconButton>
            <Button size="sm" variant="outlined" intent="neutral" className={cn(!hasKeywordChanged && 'hidden')} disabled={!keyword} onClick={onSearchSubmit}>
              {t('build:build.standard.search.button')}
            </Button>
          </div>} data-sentry-element="unknown" data-sentry-source-file="SearchInput.tsx" />
    </TextField.Root>;
};